/**
 * @file 特定のボタンを押したときにname属性を削除するグループの管理
 */
'use strict'

/**
 * @classname NameDeleteGroup
 * @classdesc 特定のボタンを押したときにname属性を削除するグループの管理
 */
export default class NameDeleteGroup {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.name-delete-group')
	 */
	constructor($e, controller) {
		console.log('NameDeleteGroup.constructor')
		this._$e = $e
		this._controller = controller
		this._$nameDeleteGroupItems = this._$e.find('.name-delete-group-item')
		this._name = this._$nameDeleteGroupItems.attr('name')
		this.setEvents()
	}


	/**
	 * イベントをセット
	 *
	 * @memberof NameDeleteGroup
	 * @return {undefined}
	 */
	setEvents() {
		console.log(`NameDeleteGroup.setEvents`)
		this._$nameDeleteGroupItems.each((_, nameDeleteGroupItem) => {
			$($(nameDeleteGroupItem).data('activate-button')).on('click', { target: $(nameDeleteGroupItem).data('activate-button') }, e => {
				console.log(e.data.target)
				this._$nameDeleteGroupItems.each((_, element) => $(element).removeAttr('name'))
				this._$e.find(`[data-activate-button='${e.data.target}']`).attr('name', this._name)
			})
		})
	}
}
